<template>
    <div class='loadBox' @click="showMore" v-if="haveMore">
        <p class='loadBtn'>{{$t('show_more')}}<span class='ui-icon icon-icon_arrow-down down-btn'></span></p>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    props: {
        haveMore: Boolean
    },
    data () {

        return {

        };

    },
    methods: {
        showMore () {

            this.$emit( 'showMore' );

        }
    }

});
</script>

<style lang='less' scope>
.loadBox{
    text-align: center;
    margin:.2rem 0 .6rem;
    cursor: pointer;
    @media @mobile{
        margin:.3rem .3rem .3rem;
    }
    .loadBtn{
        font-weight: 500;
        line-height: 1.4;
        color:@theme;
        font-size: .16rem;
        @media @mobile{
            font-size: .26rem;
            margin-bottom: .4rem;
        }
        .down-btn{
            margin-left: .08rem;
            @media @mobile{
                font-size: .28rem;
                margin-left: .16rem;
            }
        }
    }
}
</style>
